import Axios, {AxiosHeaders, AxiosResponse, RawAxiosRequestConfig} from 'axios';
import {BASE_URL} from './config';
import {UnexpectedRequestError, UserStatusError} from './errorHandler';

export const api = Axios.create({
  baseURL: BASE_URL,
  headers: {
    'Accept-Language': 'fa-IR',
  },
});

api.interceptors.request.use(
  async config => {
    const userProfile = window.localStorage.getItem('user');

    userProfile &&
      userProfile !== 'null' &&
      config.headers &&
      (config.headers as AxiosHeaders).set(
        'Authorization',
        `Token ${JSON.parse(userProfile)?.token}`,
      );
    return {
      ...config,
      params: {
        ...config.params,
        ...(userProfile &&
          JSON.parse(userProfile)?.profile?.role === 'farm' && {app: 'farm'}),
      },
    };
  },
  error => {
    Promise.reject(error);
  },
);

api.interceptors.response.use(
  response => {
    return response;
  },
  async function (error) {
    // toast.error(error?.response?.data?.message);
    // const originalRequest = error.config;

    // if (error?.response?.status === 401) {
    //   window.localStorage.clear();
    //   return (window.location.href = '/auth/login');

    //   return api(originalRequest);
    // }

    if (error?.response && 'status' in error?.response) {
      if (
        window.location.href.includes('/set-story/') &&
        error?.response?.status === 403
      ) {
        return Promise.reject(error);
      }
      if (
        error?.response?.status >= 400 &&
        error?.response?.status < 500 &&
        error.response.status in UserStatusError
      ) {
        Promise.reject(UserStatusError[error?.response?.status](error));
      }
      if (error?.response?.status >= 500) {
        const serviceError = new UnexpectedRequestError();
        serviceError.formatErrorsIntoReadableStr();
      }
    }

    return Promise.reject(error);
  },
);

const request = {
  get: <T>(
    endpoint: string,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse<T>> => {
    return api.get(endpoint, options);
  },
  post: (
    endpoint: string,
    data?: unknown,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    return api.post(endpoint, data, options);
  },
  put: (
    endpoint: string,
    data: unknown,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    return api.put(endpoint, data, options);
  },
  patch: (
    endpoint: string,
    data?: unknown,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    // return api.patch(endpoint, Object.assign({}, data), options);
    return api.patch(endpoint, data, options);
  },
  delete: (
    endpoint: string,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    return api.delete(endpoint, options);
  },
  options: (
    endpoint: string,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    return api.options(endpoint, options);
  },

  head: (
    endpoint: string,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse> => {
    return api.head(endpoint, options);
  },
};

export default request;
